import { Space, Title } from '@mantine/core';

import { PageLoading } from '@/pages/PageLoading';
import { useArtistParameters } from '@/pages/artist/onboard/components/stages/parameters/hooks/useArtistParameters.ts';
import { translate } from '@/shared/i18n/translate';
import { LBButton, LBNumberInput } from '@/shared/ui-kit/components';

export const ArtistParameters = () => {
  const { state, functions } = useArtistParameters();
  if (state.isLoading) return <PageLoading />;
  return (
    <form style={{ height: '100%' }} onSubmit={functions.onSubmit}>
      <Title order={1}>
        {translate('pages.onboarding.artist.parametres.title')}
      </Title>
      <Space h={32} />
      <LBNumberInput
        key={state.form.key('height')}
        disabled={state.form.submitting}
        label={translate('commons.artistParametres.height')}
        placeholder='00'
        rightSection={translate('commons.cm')}
        w='100%'
        {...state.form.getInputProps('height')}
      />
      <Space h={16} />
      <LBNumberInput
        key={state.form.key('weight')}
        disabled={state.form.submitting}
        label={translate('commons.artistParametres.weight')}
        placeholder='00'
        rightSection={translate('commons.kg')}
        w='100%'
        {...state.form.getInputProps('weight')}
      />
      <Space h={16} />
      <LBNumberInput
        key={state.form.key('chest')}
        disabled={state.form.submitting}
        label={translate('commons.artistParametres.chest')}
        placeholder='00'
        rightSection={translate('commons.cm')}
        w='100%'
        {...state.form.getInputProps('chest')}
      />
      <Space h={16} />
      <LBNumberInput
        key={state.form.key('waist')}
        disabled={state.form.submitting}
        label={translate('commons.artistParametres.waist')}
        placeholder='00'
        rightSection={translate('commons.cm')}
        w='100%'
        {...state.form.getInputProps('waist')}
      />
      <Space h={16} />
      <LBNumberInput
        key={state.form.key('hips')}
        disabled={state.form.submitting}
        label={translate('commons.artistParametres.hips')}
        placeholder='00'
        rightSection={translate('commons.cm')}
        w='100%'
        {...state.form.getInputProps('hips')}
      />

      <Space h={48} />
      <LBButton
        fullWidth
        disabled={!state.isFormValid}
        loading={state.form.submitting}
        type='submit'
      >
        {translate('commons.save-and-continue')}
      </LBButton>
    </form>
  );
};
